/* immune-plus-lp.js — PetHeal Landing Page JS */

(function () {
  'use strict';

  /* ─── FAQ ACCORDION ─────────────────────────────────────────── */
  document.querySelectorAll('.ph-faq-question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      var answer = this.nextElementSibling;

      // Close all
      document.querySelectorAll('.ph-faq-question').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        if (b.nextElementSibling) b.nextElementSibling.hidden = true;
      });

      // Toggle clicked
      if (!expanded) {
        this.setAttribute('aria-expanded', 'true');
        answer.hidden = false;
      }
    });
  });

  /* ─── SUBSCRIBE / OTP TOGGLE ────────────────────────────────── */
  var subGroup  = document.getElementById('subscribe-group');
  var otpGroup  = document.getElementById('otp-group');
  var toggleBtns = document.querySelectorAll('.ph-toggle-btn');

  toggleBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      toggleBtns.forEach(function (b) { b.classList.remove('ph-toggle-btn--active'); });
      this.classList.add('ph-toggle-btn--active');

      if (this.dataset.tab === 'subscribe') {
        subGroup.classList.remove('ph-package-group--hidden');
        otpGroup.classList.add('ph-package-group--hidden');
      } else {
        subGroup.classList.add('ph-package-group--hidden');
        otpGroup.classList.remove('ph-package-group--hidden');
      }

      // Auto-select first package in revealed group
      var firstPkg = (this.dataset.tab === 'subscribe' ? subGroup : otpGroup).querySelector('.ph-package');
      if (firstPkg) selectPackage(firstPkg);
    });
  });

  /* ─── PACKAGE SELECTION ──────────────────────────────────────── */
  function selectPackage(el) {
    var group = el.closest('.ph-package-group');
    group.querySelectorAll('.ph-package').forEach(function (p) {
      p.classList.remove('ph-package--selected');
    });
    el.classList.add('ph-package--selected');

    // Update hidden variant and quantity inputs for the native Shopify cart form.
    var variantId = el.dataset.variant;
    var quantity = el.dataset.qty || '1';
    var variantInput = document.getElementById('ph-variant-id');
    var quantityInput = document.getElementById('ph-quantity');
    if (variantInput && variantId) {
      variantInput.value = variantId;
    }
    if (quantityInput) {
      quantityInput.value = quantity;
    }
  }

  document.querySelectorAll('.ph-package').forEach(function (pkg) {
    pkg.addEventListener('click', function () {
      selectPackage(this);
    });
  });

  // Auto-select best value on load
  var defaultPkg = document.querySelector('#subscribe-group .ph-package--best');
  if (defaultPkg) selectPackage(defaultPkg);

  /* ─── STICKY NAV CTA SMOOTH SCROLL ──────────────────────────── */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ─── ATC FORM SUBMISSION ─────────────────────────────────────
     Submits to Shopify /cart/add endpoint.
     The form's native action="/cart/add" method="post" works out of the box
     for standard Shopify themes. If using a headless/custom setup, replace
     this handler with your cart API call.
  ────────────────────────────────────────────────────────────── */
  var atcForm = document.getElementById('ph-atc-form');
  if (atcForm) {
    atcForm.addEventListener('submit', function (e) {
      var variantInput = document.getElementById('ph-variant-id');
      if (!variantInput || !variantInput.value) {
        e.preventDefault();
        console.warn('[PetHeal LP] No valid variant ID set. Select the Immune Plus product in the section settings.');
        alert('Please select the Immune Plus product in the theme editor before checking out.');
      }
      // Otherwise, native form submit to /cart/add proceeds normally.
    });
  }

})();
